import script from "./ClosePopupButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClosePopupButton.vue?vue&type=script&setup=true&lang=ts"

import "./ClosePopupButton.vue?vue&type=style&index=0&id=1f4465d1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f4465d1"]])

export default __exports__